export const FormType = {
    CREATE: 'CREATE',
    READ: 'READ',
    UPDATE: 'UPDATE',
};



// WEBPACK FOOTER //
// ./src/app/shared/model/FormType.js